import React, {FC} from 'react';
import {useSelector} from 'react-redux';
import {useLocalizer} from '@/common/services/localizer';
import {LocationSunTime} from '@/common/interfaces/location';
import {checkIsNightNow} from '@/app/helpers/checkIsNightNow';
import {temperatureDisplayReduce} from '@/common/helpers/unitReducers/temperatureDisplayReduce';
import {selectTemperatureUnit} from '@/app/store/config/selectors';
import {ConditionLargeIcon} from '@/common/components/ConditionLargeIcon';
import {WeatherThermometer} from '../../WeatherThermometer';
import styles from './WeatherDailyOverall.css';

interface WeatherDailyOverallProps {
	condition: number;
	temperature: number;
	waterTemperature?: number;
	sunTime: LocationSunTime;
	timezoneOffset: number;
}

export const WeatherDailyOverall: FC<WeatherDailyOverallProps> = props => {
	const {condition, temperature, waterTemperature, sunTime, timezoneOffset} = props;
	const temperatureUnit = useSelector(selectTemperatureUnit);

	const t = useLocalizer();

	return (
		<div className={styles.root}>
			<ConditionLargeIcon
				className={styles.icon}
				condition={condition}
				isNight={checkIsNightNow(sunTime, timezoneOffset)}
			/>
			<WeatherThermometer className={styles.thermometer} temperature={temperature} />
			<p className={styles.temperature}>{temperatureDisplayReduce(temperature, temperatureUnit, true)}</p>

			{waterTemperature && (
				<p className={styles.waterTemperature}>
					{t('waterTemp')}{' '}
					<strong>{temperatureDisplayReduce(waterTemperature, temperatureUnit, true)}</strong>
				</p>
			)}
		</div>
	);
};

WeatherDailyOverall.displayName = 'WeatherDailyOverall';
